var _defs, _path, _g, _path2, _path3, _g2, _path4, _polygon, _g3, _polygon2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 200 104",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil2 {fill:none}\n    .fil4 {fill:#FEFEFE}\n    .fil1 {fill:white}\n    .fil6 {fill:#663300;fill-rule:nonzero}\n    .fil5 {fill:url(#a)}\n    .fil0 {fill:url(#c)}\n    .fil3 {fill:url(#b)}\n   \n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156 8c-1 0-3 0-3 1-1 0 0 1 0 2-1 1-2 1-3 1-4-2-7-4-11-6 2-3 1-6-2-6-2 0-4 0-5 1-4 0-8 0-12 1-2 1-2 3-4 4-1 2-3 4-4 6-2 2-5 5-6 8-4 6-4 13-1 19 4 6 11 9 18 9 4 0 8-3 12-1 1 1 3 2 3 4 1 2 0 3 0 5 1 3 4 4 5 7 1 1 1 4 1 6 1 3-1 4-2 7s1 6 2 8c2 4 3 8 4 12 2 3 3 9 8 8 4 0 10-6 12-9 1-1 0-4 1-5 0-1 2-1 3-2 2-3 1-6 3-9 2-2 4-3 5-5 1-4-1-6-2-10s3-7 6-10c2-3 6-6 8-9 2-2 2-6-2-6s-6 0-9-3-5-8-6-12c-2-3-3-8-6-11-2-3-5-2-7-3s-4-2-6-2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m194 75c-1 3-2 7-3 10s-2 10-7 7c-1-1-1-3-1-5 1-2 2-3 2-4 0-2-1-2 0-4s4-2 5-4 2-3 3-5c0 2 1 3 1 5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m200 19h-6v-7h-7v7h-6v6h6v6h7v-6h6v-6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 195.16,
    x2: 185.68,
    y1: 25.969,
    y2: 17.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f60",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 172.57,
    x2: 123.69,
    y1: 74.182,
    y2: 30.153,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 192.76,
    x2: 184.35,
    y1: 85.371,
    y2: 77.792,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m156 8c-1 0-3 0-3 1-1 0 0 1 0 2-1 1-2 1-3 1-4-2-7-4-11-6 2-3 1-6-2-6-2 0-4 0-5 1-4 0-8 0-12 1-2 1-2 3-4 4-1 2-3 4-4 6-2 2-5 5-6 8-4 6-4 13-1 19 4 6 11 9 18 9 4 0 8-3 12-1 1 1 3 2 3 4 1 2 0 3 0 5 1 3 4 4 5 7 1 1 1 4 1 6 1 3-1 4-2 7s1 6 2 8c2 4 3 8 4 12 2 3 3 9 8 8 4 0 10-6 12-9 1-1 0-4 1-5 0-1 2-1 3-2 2-3 1-6 3-9 2-2 4-3 5-5 1-4-1-6-2-10s3-7 6-10c2-3 6-6 8-9 2-2 2-6-2-6s-6 0-9-3-5-8-6-12c-2-3-3-8-6-11-2-3-5-2-7-3s-4-2-6-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil1",
    d: "m175 37h2l4-6h1l-5 7c1 0 1 1 1 1 0 1-1 2-2 2l1 13c1 1 2 2 2 3l2 1v1l-2-1c-1 1-2 1-3 1h-1l-10 7v1 1l14 11-1 1-14-11h-1-1l-4 12v2 2l9 13-1 1-9-14h-1c-1 0-2 0-3-1l-8 2v-1l8-2c0-1 1-3 3-3 0 0 0 1 1 1l5-12c-1-1-2-1-2-2s1-1 1-2l-9-16h-2s-1-1-2-1l-11 3-1-1 12-3v-1c0-1 0-1 1-2l-7-14h-1c-1 0-2-1-2-1l-15 3c0 1-1 2-2 3v17h-1v-17c-1-1-2-2-2-3v-1l-12-15 1-1 12 15h1l3-17c-1 0-2-1-2-2 0-2 1-3 3-3l2-11h1l-2 11c1 1 1 2 1 3v1l13 13h1c1 0 2 1 3 2h14c0-1 1-2 3-2l1-18h1l-1 18s1 1 1 2h17v1h-17c0 1-1 2-2 2-2 0-3-1-3-2h-14c0 1-1 1-1 1l7 15c1 0 2 0 3 1l20-6c0-1 1-2 2-2zm-45 1zm44 20v-1c0-1 1-2 2-3l-1-12c-1 0-2-1-2-2l-20 6c0 1 0 1-1 2l10 17c0-1 0-1 1-1s1 1 2 1l9-7zm-51-27 16-3v-1-1l-13-13h-1l-3 17c1 0 1 0 1 1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m156 8c-1 0-3 0-3 1-1 0 0 1 0 2-1 1-2 1-3 1-4-2-7-4-11-6 2-3 1-6-2-6-2 0-4 0-5 1-4 0-8 0-12 1-2 1-2 3-4 4-1 2-3 4-4 6-2 2-5 5-6 8-4 6-4 13-1 19 4 6 11 9 18 9 4 0 8-3 12-1 1 1 3 2 3 4 1 2 0 3 0 5 1 3 4 4 5 7 1 1 1 4 1 6 1 3-1 4-2 7s1 6 2 8c2 4 3 8 4 12 2 3 3 9 8 8 4 0 10-6 12-9 1-1 0-4 1-5 0-1 2-1 3-2 2-3 1-6 3-9 2-2 4-3 5-5 1-4-1-6-2-10s3-7 6-10c2-3 6-6 8-9 2-2 2-6-2-6s-6 0-9-3-5-8-6-12c-2-3-3-8-6-11-2-3-5-2-7-3s-4-2-6-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "m194 75c-1 3-2 7-3 10s-2 10-7 7c-1-1-1-3-1-5 1-2 2-3 2-4 0-2-1-2 0-4s4-2 5-4 2-3 3-5c0 2 1 3 1 5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g",
    className: "fil4",
    d: "m175 36c2 0 3 1 3 2 0 2-1 3-3 3-1 0-2-1-2-3 0-1 1-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m150 44c2 0 3 1 3 2 0 2-1 3-3 3-1 0-2-1-2-3 0-1 1-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m156 80c1 0 2 2 2 3s-1 2-2 2c-2 0-3-1-3-2s1-3 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m163 64c1 0 2 1 2 3 0 1-1 2-2 2s-3-1-3-2c0-2 2-3 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m176 54c2 0 3 1 3 3 0 1-1 2-3 2-1 0-2-1-2-2 0-2 1-3 2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m141 25c2 0 3 1 3 2 0 2-1 3-3 3-1 0-2-1-2-3 0-1 1-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m121 30c2 0 3 1 3 2s-1 3-3 3c-1 0-2-2-2-3s1-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m125 8c1 0 2 1 2 3 0 1-1 2-2 2-2 0-3-1-3-2 0-2 1-3 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m161 25c1 0 2 1 2 2 0 2-1 3-2 3-2 0-3-1-3-3 0-1 1-2 3-2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "127 -3 128 -3 122 30 121 30"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    transform: "matrix(-1.7858e-13 -1.2728 2.2418 -1.0139e-13 139.45 27.876)",
    width: 0.8127,
    height: 17.979
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "162 7 163 7 161 27 160 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "141 28 141 27 151 45 150 45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "126 12 127 12 141 26 140 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "122 32 122 31 141 27 141 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "121 32 122 32 122 52 121 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "121 31 120 31 107 16 108 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "151 47 152 46 163 67 162 67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "175 38 176 39 151 47 151 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "151 46 151 47 137 51 136 50"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "145 86 145 85 156 82 156 84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "156 85 157 84 167 98 166 99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    transform: "matrix(-.97052 -.70168 .36511 -.50499 175.55 39.76)",
    width: 0.8127,
    height: 17.979
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "177 55 176 55 175 39 176 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "157 82 156 82 162 67 163 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "165 66 164 66 177 56 177 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "176 57 177 56 181 58 181 59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m187 78c1 0 2 1 2 2 0 2-1 3-2 3s-3-1-3-3c0-1 2-2 3-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(.69746 -1.0633 1.3045 .93746 187.36 81.481)",
    width: 0.8127,
    height: 17.979
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m194 75c-1 3-2 7-3 10s-2 10-7 7c-1-1-1-3-1-5 1-2 2-3 2-4 0-2-1-2 0-4s4-2 5-4 2-3 3-5c0 2 1 3 1 5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "200 19 194 19 194 12 187 12 187 19 181 19 181 25 187 25 187 31 194 31 194 25 200 25"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "191 22 191 23 178 36 177 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "193 21 192 21 183 5 184 5"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "200 19 194 19 194 12 187 12 187 19 181 19 181 25 187 25 187 31 194 31 194 25 200 25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "m25 81h10l-13-29h-9l-13 29h10l2-5h11l2 5zm-10-12 3-7 2 7h-5zm31-9c0-2 1-3 2-3h2l2-6c-1-1-3-1-5-1-7 0-10 4-10 9v1h-4v6h4v15h9v-15h5v-6h-5zm19 1v-3h-9v23h9v-10c0-4 2-5 5-5h2v-8c-3 0-6 1-7 3zm13-5c4 0 6-2 6-4 0-3-2-5-6-5-3 0-5 2-5 5 0 2 2 4 5 4zm-4 25h9v-23h-9v23zm25 1c5 0 9-3 11-7l-7-4c-1 2-3 3-4 3-2 0-4-1-4-4s2-5 4-5c1 0 3 1 4 3l7-3c-2-5-6-7-11-7-8 0-14 5-14 12s6 12 14 12zm22-24c-3 0-7 1-10 2l3 7c2-1 4-2 6-2 3 0 4 1 4 3h-4c-7 0-10 2-10 6s3 8 8 8c4 0 6-2 7-4v3h9v-12c0-8-5-11-13-11zm0 18c-1 0-2-1-2-2s1-2 3-2h2v2c0 1-1 2-3 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "m18 93h-1c-2 0-2-1-2-2s0-2 2-2c1 0 1 0 2 1l1-2c0-1-2-1-3-1-3 0-5 2-5 4 0 3 2 4 5 4 1 0 2 0 3-1v-3h-2v2zm6-4h-2v2c1 0 1-1 2-1s1 1 1 1h-1c-2 0-3 1-3 2s1 2 3 2c1 0 1 0 2-1v1h2v-3c0-2-1-3-4-3zm0 5s-1 0-1-1h1 1c0 1 0 1-1 1zm9-1c0 1 0 1-1 1v-1-2h1v-2h-1v-2h-3v2h-1v2h1v2c0 2 1 2 3 2h2l-1-2zm8-1c0-2-2-3-4-3s-3 1-3 3 1 3 4 3c1 0 2 0 2-1l-1-1-1 1c-1 0-2-1-2-1h5v-1zm-4-2c1 0 2 1 2 1h-3l1-1zm14-1-2 4-1-4h-2l-1 4-2-4h-2l2 6h3l1-3 1 3h2l2-6h-1zm5 0h-3l1 2 1-1c1 0 2 1 2 1h-2c-2 0-2 1-2 2s0 2 2 2c1 0 2 0 2-1v1h2v-3c0-2-1-3-3-3zm0 5c-1 0-1 0-1-1h1 1c0 1-1 1-1 1zm9-5-2 4-1-4h-3l3 6c0 1 0 1-1 1l-1-1v2l1 1c2 0 3-1 3-3l3-6h-2zm10 4c0 1 0 1-1 1v-1-2h1v-2h-1v-2h-3v2h-1v2h1v2c0 2 1 2 3 2h2l-1-2zm5 2c2 0 3-1 3-3s-1-3-3-3c-3 0-4 1-4 3s1 3 4 3zm0-1c-1 0-2-1-2-2s1-2 2-2c0 0 1 1 1 2s-1 2-1 2zm10-5h-2v2c1 0 2-1 2-1 1 0 1 1 2 1h-2c-2 0-3 1-3 2s1 2 3 2c1 0 1 0 2-1v1h2v-3c0-2-1-3-4-3zm0 5v-1h1 1c-1 1-1 1-2 1zm8-5v-1h1l1-1c-1-1-1-1-2-1-2 0-3 1-3 3v2 4h3v-4h1v-2h-1zm5 1v-1h-2v6h2v-3c0-1 1-1 2-1v-2c-1 0-1 0-2 1zm4-2c1 0 2 0 2-1s-1-1-2-1c0 0-1 0-1 1s1 1 1 1zm-1 7h3v-6h-3v6zm7 0c2 0 3 0 3-1l-1-1c-1 0-1 1-2 1s-1-1-1-2 0-2 1-2 1 1 2 1l1-1c0-1-1-1-3-1s-3 1-3 3 1 3 3 3zm7-6h-3l1 2s1-1 2-1l1 1h-1c-2 0-3 1-3 2s1 2 2 2 2 0 2-1v1h2v-3c0-2-1-3-3-3zm0 5c-1 0-1 0-1-1h1 1c0 1-1 1-1 1zm6 1s1 0 1-1-1-1-1-1c-1 0-2 0-2 1s1 1 2 1zm3 0c1 0 1 0 1-1s0-1-1-1-1 0-1 1 0 1 1 1zm3 0c1 0 2 0 2-1s-1-1-2-1c0 0-1 0-1 1s1 1 1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "m192 19c1 0 2 1 2 2s-1 3-2 3-2-2-2-3 1-2 2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.7240e605e69fbf004fa7a497f66f8d62.svg";
export { ForwardRef as ReactComponent };